var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mode === '1')?_c('SettingLanguage',_vm._g(_vm._b({on:{"handleSetLanguage":_vm.confirm}},'SettingLanguage',_vm.$attrs,false),_vm.$listeners)):_c('LangDropdown',{on:{"handleSetLanguage":_vm.confirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }